// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__33BSD","rootCenter":"LoadMoreObserver_rootCenter__16C20","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__24a_J"};